import store from "@/store";

export default {
  install(Vue) {
    Vue.prototype.$bridge = {
      /**
       * userAgent 값을 반환홤.
       */
      userAgent: function () {
        return navigator.userAgent || navigator.vendor || window.opera;
      },
      /**
       * Android 여부를 확인함.
       */
      isAndroid: function () {
        let rtn = false;

        if (/android/i.test(this.userAgent())) {
          rtn = true;
        }
        return rtn;
      },
      /**
       * Ios 여부를 확인함.
       */
      isIos: function () {
        let rtn = false;
        if (/iPad|iPhone|iPod/.test(this.userAgent()) && !window.MSStream) {
          rtn = true;
        }
        return rtn;
      },
      /**
       * 모바일 환경인지 여부를 확인함.
       */
      isMobile: function () {
        return this.isIos() || this.isAndroid();
      },
      /**
       * 브릿지 함수 호출
       */
      bridgeCall: function (params) {
        // mobile 체크
        // if( !this.isMobile() ) {
        // 	app.$log.error("mobile 환경이 아닙니다.");
        // 	return;
        // }

        /**
         * params 레이아웃
         * {
         * 		biz : "testCall001" 		 -- string (필수)
         * ,  isLoading : true / false -- boolean
         * ,	callback : ""						 -- string
         * ,	bizParam : {}						 -- json
         * }
         */

        // 필수체크
        if (params === undefined) {
          app.$log.error("params [undefined]");
          return;
        }

        if (params.biz === undefined || params.biz === "") {
          app.$log.error("params.biz [empty]");
          return;
        }

        // 파라미터 조립
        let parameter = {};
        parameter.biz = params.biz;

        if (params.bizParam !== undefined && params.bizParam !== "") {
          parameter.bizParam = params.bizParam;
        } else {
          parameter.bizParam = {};
        }

        if (params.callback !== undefined && params.callback !== "") {
          parameter.callback = params.callback;
        } else {
          parameter.callback = "";
        }

        // parameter debug
        if (!_.isNil(app.$log)) {
          app.$log.debug(parameter);
        }

        // mobile 체크
        if (!this.isMobile()) {
          app.$log.error("mobile 환경이 아닙니다.");
          return;
        }

        // 로딩바
        if (params.isLoading !== undefined && params.isLoading === true) {
          //app.$store.dispatch("actSetLoading", true);
        }

        // app call
        try {
          if (this.isIos()) {
            // alert("window : " + (window === undefined));

            // if(window !== undefined) {
            // 	alert("window.webkit : " + (window.webkit === undefined));
            // }

            // if(window !== undefined && window.webkit !== undefined) {
            // 	alert("window.webkit.messageHandlers : " + (window.webkit.messageHandlers === undefined));
            // }

            // if(window !== undefined && window.webkit !== undefined && window.webkit.messageHandlers !== undefined) {
            // 	alert("window.webkit.messageHandlers.scriptHandler : " + (window.webkit.messageHandlers.scriptHandler === undefined));
            // }
            window.webkit.messageHandlers.scriptHandler.postMessage(parameter);
          } else if (this.isAndroid()) {
            window.android.loadlink(JSON.stringify(parameter));
          }
        } catch (e) {
          // dummy call [S] ■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■
          if (parameter.callback !== "") {
            let dummyBizParam = {};
            switch (parameter.callback) {
              case "SSInfogetMotp_callback":
                dummyBizParam = {
                  Motpinfo: [
                    {
                      strUserId: "G16004651000000",
                      secret: "dfefewfsdfadsafasdfasdfsdf....",
                    },
                    {
                      strUserId: "G21000009100000",
                      secret: "dfefewfsdfadsafasdfasdfsdf....",
                    },
                    {
                      strUserId: "G16000007500000",
                      secret: "dfefewfsdfadsafasdfasdfsdf....",
                    },
                    {
                      strUserId: "G16000007500001",
                      secret: "dfefewfsdfadsafasdfasdfsdf....",
                    },
                    {
                      strUserId: "G19000154100000",
                      secret: "dfefewfsdfadsafasdfasdfsdf....",
                    },
                  ],
                };
                break;
              case "SSInfogetMotp_pinNoMgt_callback":
                dummyBizParam = {
                  Motpinfo: [
                    {
                      strUserId: "G21000009100000",
                      secret: "dfefewfsdfadsafasdfasdfsdf....",
                    },
                    {
                      strUserId: "G16000007500000",
                      secret: "dfefewfsdfadsafasdfasdfsdf....",
                    },
                    {
                      strUserId: "G16000007500001",
                      secret: "dfefewfsdfadsafasdfasdfsdf....",
                    },
                    {
                      strUserId: "G16004099300000",
                      secret: "dfefewfsdfadsafasdfasdfsdf....",
                    },
                  ],
                };
                break;
              case "SSSInfogetMotp_unlockAuthErr_callback":
                dummyBizParam = {
                  Motpinfo: [
                    {
                      strUserId: "G21000009100000",
                      secret: "dfefewfsdfadsafasdfasdfsdf....",
                    },
                    {
                      strUserId: "G16000007500000",
                      secret: "dfefewfsdfadsafasdfasdfsdf....",
                    },
                    {
                      strUserId: "G16000007500001",
                      secret: "dfefewfsdfadsafasdfasdfsdf....",
                    },
                    {
                      strUserId: "G16003792000000",
                      secret: "dfefewfsdfadsafasdfasdfsdf....",
                    },
                  ],
                };
                break;
              case "SSInfogetMotp_reregisterOtp_callback":
                dummyBizParam = {
                  Motpinfo: [
                    {
                      strUserId: "G21000009100000",
                      secret: "dfefewfsdfadsafasdfasdfsdf....",
                    },
                    {
                      strUserId: "G16000007500000",
                      secret: "dfefewfsdfadsafasdfasdfsdf....",
                    },
                    {
                      strUserId: "G16000007500001",
                      secret: "dfefewfsdfadsafasdfasdfsdf....",
                    },
                    {
                      strUserId: "G16003792000000",
                      secret: "dfefewfsdfadsafasdfasdfsdf....",
                    },
                  ],
                };
                break;
              case "SSInfogetMotp_mOtpExstYN_callback":
                dummyBizParam = {
                  Motpinfo: [
                    {
                      strUserId: "G16004651000000",
                      secret: "dfefewfsdfadsafasdfasdfsdf....",
                    },
                    {
                      strUserId: "G16004099300000",
                      secret: "dfefewfsdfadsafasdfasdfsdf....",
                    },
                    {
                      strUserId: "G16000007500001",
                      secret: "dfefewfsdfadsafasdfasdfsdf....",
                    },
                    {
                      strUserId: "G19000154100000",
                      secret: "dfefewfsdfadsafasdfasdfsdf....",
                    },
                  ],
                };
                break;
              case "SSSInfogetMotp_certnStupModfiMotp_callback":
                dummyBizParam = {
                  Motpinfo: [
                    {
                      strUserId: "G21000009100000",
                      secret: "dfefewfsdfadsafasdfasdfsdf....",
                    },
                    {
                      strUserId: "G16000007500000",
                      secret: "dfefewfsdfadsafasdfasdfsdf....",
                    },
                    {
                      strUserId: "G16000007500001",
                      secret: "dfefewfsdfadsafasdfasdfsdf....",
                    },
                    {
                      strUserId: "G16003792000000",
                      secret: "dfefewfsdfadsafasdfasdfsdf....",
                    },
                  ],
                };
                break;
              case "SSInfogetMotp_motpCertn_callback":
                dummyBizParam = {
                  Motpinfo: [
                    {
                      strUserId: "G16001022400000",
                      secret: "dfefewfsdfadsafasdfasdfsdf....",
                    },
                    {
                      strUserId: "G16000007500000",
                      secret: "dfefewfsdfadsafasdfasdfsdf....",
                    },
                    {
                      strUserId: "G16004425000000",
                      secret: "dfefewfsdfadsafasdfasdfsdf....",
                    },
                    {
                      strUserId: "G19000154100000",
                      secret: "dfefewfsdfadsafasdfasdfsdf....",
                    },
                  ],
                };
                break;
              case "SSInfogetMotp_callback_cert":
                dummyBizParam = {
                  Motpinfo: [
                    {
                      strUserId: "G16004651000000",
                      secret: "dfefewfsdfadsafasdfasdfsdf....",
                    },
                    {
                      strUserId: "G16004099300000",
                      secret: "dfefewfsdfadsafasdfasdfsdf....",
                    },
                    {
                      strUserId: "G16004149600000",
                      secret: "dfefewfsdfadsafasdfasdfsdf....",
                    },
                    {
                      strUserId: "G16003792000000",
                      secret: "dfefewfsdfadsafasdfasdfsdf....",
                    },
                    {
                      strUserId: "G19000154100000",
                      secret: "dfefewfsdfadsafasdfasdfsdf....",
                    },
                  ],
                };
                break;
              case "SSInfogetMotp_discardOrReportMotp_callback":
                dummyBizParam = {
                  Motpinfo: [
                    {
                      strUserId: "G19000045600000",
                      secret: "iOS:EC88921C-924A-4B60-877F-5265C30721FB",
                    },
                  ],
                };
                break;
              case "SSRegisterMotpPin_callback":
                dummyBizParam = {
                  result: "SUCCESS",
                  publickey: "WWh54sESdqkmoLIQlVYuJYD0CsOD+i0kQIDAQAB",
                  userdata: "mo/uTevbFVhnjvL2J0tgCGsNg4tHTtc4YtqIsWGvybBKG84qyoMxhz6",
                  errorcode: "203",
                };
                break;
              case "SSInitializeMotp_callback":
                dummyBizParam = {
                  result: "SUCCESS",
                  secret: "dkdkfeidiif88833434kdkfjfjf....",
                  errorcode: "201",
                };
                break;
              case "SSGenerateMotp_callback_PC":
                dummyBizParam = {
                  result: "SUCCESS",
                  motp: Math.floor(Math.random() * 99999) + 100000,
                  errorcode: "201",
                  failcount: "0",
                };
                break;
              case "SSRegisterMotpPin_pinNoMgt_callback":
                dummyBizParam = {
                  result: "SUCCESS",
                  publickey: "WWh54sESdqkmoLIQlVYuJYD0CsOD+i0kQIDAQAB",
                  userdata: "mo/uTevbFVhnjvL2J0tgCGsNg4tHTtc4YtqIsWGvybBKG84qyoMxhz6",
                  errorcode: "203",
                };
                break;
              case "SSInitializeMotp_pinNoMgt_callback":
                dummyBizParam = {
                  result: "SUCCESS",
                  secret: "dkdkfeidiif88833434kdkfjfjf....",
                  errorcode: "201",
                };
                break;
              case "SSGenerateMotp_pinNoMgt_callback":
                dummyBizParam = {
                  result: "SUCCESS",
                  motp: Math.floor(Math.random() * 99999) + 100000,
                  errorcode: "201",
                  failcount: "0",
                };
                break;
              case "fidoReg_callback":
                dummyBizParam = {
                  result: "SUCCESS",
                  uafResponse: "xxxxxxdfefefefaefefewfew.......",
                  errorcode: "100",
                };
                break;
              case "fidoCertn_callback":
                dummyBizParam = {
                  result: "SUCCESS",
                  uafResponse: "xxxxxxdfefefefaefefewfew.......",
                  errorcode: "51",
                  failcount: "0",
                };
                break;
              case "fidoCertn_callback_general":
                dummyBizParam = {
                  result: "SUCCESS",
                  uafResponse: "xxxxxxdfefefefaefefewfew.......",
                  errorcode: "200",
                  failcount: "0",
                };
                break;
              case "fidoCertn_callback_supplCertn":
                dummyBizParam = {
                  result: "SUCCESS",
                  uafResponse: "xxxxxxdfefefefaefefewfew.......",
                  errorcode: "101",
                  failcount: "0",
                };
                break;
              case "fidoReg_callback_simpleLogin":
                dummyBizParam = {
                  result: "SUCCESS",
                  uafResponse: "xxxxxxdfefefefaefefewfew.......",
                  errorcode: "101",
                  failcount: "0",
                };
                break;
              case "fidoReg_callback_fidoReq":
                dummyBizParam = {
                  result: "SUCCESS",
                  uafResponse: "xxxxxxdfefefefaefefewfew.......",
                  errorcode: "100",
                };
                break;
              case "fidoRegInfo_callback":
                dummyBizParam = {
                  Fidoinfo: [
                    {
                      userName: "G16003792000000",
                      isPincode: "1",
                      isFingerprint: "1",
                      isPattern: "0",
                    },
                    {
                      userName: "G16004099300000",
                      isPincode: "1",
                      isFingerprint: "1",
                      isPattern: "0",
                    },
                    {
                      userName: "G19000154100000",
                      isPincode: "1",
                      isFingerprint: "1",
                      isPattern: "0",
                    },
                    {
                      userName: "G13001766200000",
                      isPincode: "1",
                      isFingerprint: "1",
                      isPattern: "0",
                    },
                  ],
                };
                break;
              case "fidoRegInfo_supplCertn_callback":
                dummyBizParam = {
                  Fidoinfo: [
                    {
                      userName: "G16003792000000",
                      isPincode: "1",
                      isFingerprint: "1",
                      isPattern: "0",
                    },
                    {
                      userName: "G16004099300000",
                      isPincode: "1",
                      isFingerprint: "1",
                      isPattern: "0",
                    },
                    {
                      userName: "G19000154100000",
                      isPincode: "1",
                      isFingerprint: "1",
                      isPattern: "0",
                    },
                    {
                      userName: "G13001766200000",
                      isPincode: "1",
                      isFingerprint: "1",
                      isPattern: "0",
                    },
                  ],
                };
                break;
              case "fidoRegInfo_callback_bfLogin":
                dummyBizParam = {
                  Fidoinfo: [
                    {
                      userName: "G16004099300000",
                      isPincode: "1",
                      isFingerprint: "1",
                      isPattern: "0",
                    },
                    {
                      userName: "G16000061900000",
                      isPincode: "1",
                      isFingerprint: "1",
                      isPattern: "0",
                    },
                    {
                      userName: "G19000154100000",
                      isPincode: "1",
                      isFingerprint: "1",
                      isPattern: "0",
                    },
                    {
                      userName: "G13001766200000",
                      isPincode: "1",
                      isFingerprint: "1",
                      isPattern: "0",
                    },
                  ],
                };
                break;
              case "simpleLogin_callback":
                dummyBizParam = {
                  userName: "G13001766200000",
                  bioType: "PINCODE",
                };
                break;
              case "getNativeData_callback":
                dummyBizParam = {
                  pgmVsnno: "v12.0.0.1",
                  initUser: false,
                };
                break;
              case "SSInfogetMotp_supplCertn_callback":
                dummyBizParam = {
                  Motpinfo: [
                    {
                      strUserId: "G16001022400000",
                      secret: "dfefewfsdfadsafasdfasdfsdf....",
                    },
                    {
                      strUserId: "G16004099300000",
                      secret: "dfefewfsdfadsafasdfasdfsdf....",
                    },
                    {
                      strUserId: "G16004149600000",
                      secret: "dfefewfsdfadsafasdfasdfsdf....",
                    },
                    {
                      strUserId: "G19000154100000",
                      secret: "dfefewfsdfadsafasdfasdfsdf....",
                    },
                  ],
                };
                break;
              case "SSGenerateMotp_supplCertn_callback":
                dummyBizParam = {
                  result: "SUCCESS",
                  motp: Math.floor(Math.random() * 99999) + 100000,
                  errorcode: "201",
                  failcount: "0",
                };
                break;
              case "fidoDiscard_callback":
                dummyBizParam = {
                  result: "SUCCESS",
                  uafResponse: "xxxxxxdfefefefaefefewfew.......",
                  errorcode: "",
                };
                break;
              case "qrScanForTransfer_callback":
                dummyBizParam = {
                  result: "SUCCESS",
                  data: "callback data",
                };
                break;
              // 사진 from Gallery 콜백 추가
              case "getQRFromGallery_callback":
                dummyBizParam = {
                  result: "SUCCESS",
                  data: "gallery callback data",
                  decodedData: {
                    title: "",
                    content: "",
                  },
                };
                break;
              case "recognizeId_callback":
                dummyBizParam = {
                  result: "SUCCESS",
                  idType: "ID",
                  image: "",
                  data: {
                    idType: "", //ID타입
                    issueCountry: "", //발행국가
                    lastName: "", //이름(성)
                    givenName: "", //이름
                    idNumber: "", //ID번호
                    nationality: "", //국적
                    dateOfBirth: "", //생년월일
                    gender: "", //성별
                    expireDate: "", //기간만료일
                    mrz1: "MRZ 1",
                    mrz2: "MRZ 2",
                  },
                };
                break;
              case "registeredBiometry_callback":
                dummyBizParam = {
                  result: "1",
                };
                break;
              case "checkPermissions_callback":
                dummyBizParam = {
                  data: "0",
                };
                break;
              case "requestPermissions_callback":
                dummyBizParam = {
                  data: "0",
                };
                break;
            }

            const dummy = btoa(JSON.stringify({ biz: parameter.callback, bizParam: dummyBizParam }));
            setTimeout(function () {
              nativeCall(dummy);
            }, 500);
          }

          if (params.biz === "openKeypadForMotpReg1") {
            const dummy = btoa(JSON.stringify({ biz: "sendKeypadData_callback", bizParam: { inputId: "mPin01", inputValue: "121212" } }));
            setTimeout(function () {
              nativeCall(dummy);
            }, 1000);
          }

          if (params.biz === "openKeypadForMotpReg2") {
            const dummy = btoa(JSON.stringify({ biz: "sendKeypadData_callback", bizParam: { inputId: "mPin02", inputValue: "121212" } }));
            setTimeout(function () {
              nativeCall(dummy);
            }, 1000);
          }

          if (params.biz === "openKeypadForPinNoMgt1") {
            const dummy = btoa(JSON.stringify({ biz: "sendKeypadData_pinNoMgt_callback", bizParam: { inputId: "mPin01", inputValue: "160938" } }));
            setTimeout(function () {
              nativeCall(dummy);
            }, 1000);
          }

          if (params.biz === "openKeypadForPinNoMgt2") {
            const dummy = btoa(JSON.stringify({ biz: "sendKeypadData_pinNoMgt_callback", bizParam: { inputId: "mPin02", inputValue: "160938" } }));
            setTimeout(function () {
              nativeCall(dummy);
            }, 1000);
          }

          if (params.biz === "openKeypadForFidoReg1") {
            const dummy = btoa(JSON.stringify({ biz: "sendKeypadData_callback_Fido", bizParam: { inputId: "mPin01", inputValue: "121212" } }));
            setTimeout(function () {
              nativeCall(dummy);
            }, 1000);
          }

          if (params.biz === "openKeypadForFidoReg2") {
            const dummy = btoa(JSON.stringify({ biz: "sendKeypadData_callback_Fido", bizParam: { inputId: "mPin02", inputValue: "121212" } }));
            setTimeout(function () {
              nativeCall(dummy);
            }, 1000);
          }
          // dummy call [E] ■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■
        }
      },
      /**
       * 테스트 call
       */
      testCall001: function () {
        const json = {
          biz: "testCall001",
        };
        this.bridgeCall(json);
      },
      /**
       * native alert 함수를 호출한다.
       * @param {*} msg
       */
      openAlert: function (msg, callback) {
        const json = {
          biz: "openAlert",
          callback: callback,
          isLoading: true,
          bizParam: {
            message: msg,
          },
        };
        this.bridgeCall(json);
      },
      /**
       * native에 저장된 json 데이터를 가져온다.
       * @param {*} keys
       */
      getNativeData: function (keys) {
        const json = {
          biz: "getNativeData",
          callback: "getNativeData_callback",
          bizParam: {
            keys: keys,
          },
        };
        this.bridgeCall(json);
      },
      /**
       * native에 json 데이터를 저장한다.
       * @param {*} params
       */
      setNativeData: function (params) {
        const json = {
          biz: "setNativeData",
          bizParam: params,
        };
        this.bridgeCall(json);
      },
      /**
       * mOTP 발급시, 발급정보를 가져온다.
       */
      SSInfogetMotp: function () {
        const json = {
          biz: "SSInfogetMotp",
          callback: "SSInfogetMotp_callback",
          isLoading: true,
          bizParam: {},
        };
        this.bridgeCall(json);
      },
      /**
       * mOTP 등록시 첫번째 mpin 입력 native 키패드를 호출한다.
       */
      openKeypadForMotpReg1: function () {
        const json = {
          biz: "openKeypadForMotpReg1",
          callback: "sendKeypadData_callback",
          bizParam: {
            inputId: "mPin01",
          },
        };
        this.bridgeCall(json);
      },
      /**
       * mOTP 등록시 두번째 mpin 입력 native 키패드를 호출한다.
       */
      openKeypadForMotpReg2: function () {
        const json = {
          biz: "openKeypadForMotpReg2",
          callback: "sendKeypadData_callback",
          bizParam: {
            inputId: "mPin02",
          },
        };
        this.bridgeCall(json);
      },
      /**
       * mOTP 등록
       * @param {*} mOtpId
       */
      SSRegisterMotpPin: function (mOtpId, systemId) {
        const json = {
          biz: "SSRegisterMotpPin",
          callback: "SSRegisterMotpPin_callback",
          isLoading: true,
          bizParam: {
            strUserId: mOtpId,
            strSystemId: systemId,
          },
        };
        this.bridgeCall(json);
      },
      /**
       * mOTP 폐기
       * @param {*} mOtpId
       */
      SSDiscardMotpPin: function (mOtpId, systemId) {
        const json = {
          biz: "SSDiscardMotpPin",
          isLoading: true,
          bizParam: {
            strUserId: mOtpId,
          },
        };
        this.bridgeCall(json);
      },
      /**
       * mOTP 등록시 app정보 초기화
       * @param {*} initialInfo
       */
      SSInitializeMotp: function (initialInfo) {
        const json = {
          biz: "SSInitializeMotp",
          callback: "SSInitializeMotp_callback",
          isLoading: true,
          bizParam: {
            strUserId: initialInfo.strUserId,
            strSystemId: initialInfo.strSystemId,
            strMotpInfo: initialInfo.strMotpInfo,
            strSKey: initialInfo.strSKey,
          },
        };
        this.bridgeCall(json);
      },
      /**
       * mOTP 인증을 호출한다.(native키패드를 열고 mpin을 입력 받음) - mOTP PC인증
       * @param {*} certInfo
       */
      SSGenerateMotp: function (certInfo) {
        const json = {
          biz: "SSGenerateMotp",
          callback: "SSGenerateMotp_callback_PC",
          isLoading: true,
          bizParam: {
            strUserId: certInfo.strUserId,
            strPeriod: certInfo.strPeriod,
            strSystemId: certInfo.strSystemId,
          },
        };
        this.bridgeCall(json);
      },
      /**
       * mOTP 인증을 호출한다.(native키패드 없이..) - mOTP PC인증
       * @param {*} certInfo
       */
      SSGenerateMotp_ReGenerate: function (certInfo) {
        const json = {
          biz: "SSGenerateMotp_ReGenerate",
          callback: "SSGenerateMotp_callback_PC",
          isLoading: true,
          bizParam: {
            strUserId: certInfo.strUserId,
            strPeriod: certInfo.strPeriod,
            strSystemId: certInfo.strSystemId,
          },
        };
        this.bridgeCall(json);
      },
      /**
       * mOTP 인증시, 발급정보를 가져온다.
       */
      SSInfogetCertMotp: function () {
        const json = {
          biz: "SSInfogetMotp",
          callback: "SSInfogetMotp_callback_cert",
          isLoading: true,
          bizParam: {},
        };
        this.bridgeCall(json);
      },
      /**
       * mOTP 발급시, 발급정보를 가져온다. (mtop인증)
       */
      SSInfogetMotp_motpCertn: function () {
        const json = {
          biz: "SSInfogetMotp",
          callback: "SSInfogetMotp_motpCertn_callback",
          isLoading: true,
          bizParam: {},
        };
        this.bridgeCall(json);
      },
      /**
       * mOTP 인증시, 발급정보를 가져온다.(pin관리)
       */
      SSRegisterMotpPin_pinNoMgt: function (mOtpId, systemId) {
        const json = {
          biz: "SSRegisterMotpPin",
          callback: "SSRegisterMotpPin_pinNoMgt_callback",
          isLoading: true,
          bizParam: {
            strUserId: mOtpId,
            strSystemId: systemId,
          },
        };
        this.bridgeCall(json);
      },
      /**
       * mOTP 등록시 첫번째 mpin 입력 native 키패드를 호출한다.(pin관리)
       */
      openKeypadForMotpReg1_pinNoMgt: function () {
        const json = {
          biz: "openKeypadForPinNoMgt1",
          callback: "sendKeypadData_pinNoMgt_callback",
          bizParam: {
            inputId: "mPin01",
          },
        };
        this.bridgeCall(json);
      },

      /**
       * mOTP 등록시 두번째 mpin 입력 native 키패드를 호출한다. (pin관리)
       */
      openKeypadForMotpReg2_pinNoMgt: function () {
        const json = {
          biz: "openKeypadForPinNoMgt2",
          callback: "sendKeypadData_pinNoMgt_callback",
          bizParam: {
            inputId: "mPin02",
          },
        };
        this.bridgeCall(json);
      },

      /**
       * mOTP 등록시 app정보 초기화 (pin관리)
       * @param {*} initialInfo
       */
      SSInitializeMotp_pinNoMgt: function (initialInfo) {
        const json = {
          biz: "SSInitializeMotp",
          callback: "SSInitializeMotp_pinNoMgt_callback",
          isLoading: true,
          bizParam: {
            strUserId: initialInfo.strUserId,
            strSystemId: initialInfo.strSystemId,
            strMotpInfo: initialInfo.strMotpInfo,
            strSKey: initialInfo.strSKey,
          },
        };
        this.bridgeCall(json);
      },
      /**
       * mOTP 발급시, 발급정보를 가져온다. (pin관리)
       */
      SSInfogetMotp_pinNoMgt: function () {
        const json = {
          biz: "SSInfogetMotp",
          callback: "SSInfogetMotp_pinNoMgt_callback",
          isLoading: true,
          bizParam: {},
        };
        this.bridgeCall(json);
      },
      /**
       * mOTP 발급시, 발급정보를 가져온다. (인증오류해제)
       */
      SSInfogetMotp_unlockAuthErr: function () {
        const json = {
          biz: "SSInfogetMotp",
          callback: "SSSInfogetMotp_unlockAuthErr_callback",
          isLoading: true,
          bizParam: {},
        };
        this.bridgeCall(json);
      },
      /**
       * mOTP 발급시, 발급정보를 가져온다. (인증설정변경)
       */
      SSInfogetMotp_certnStupModfiMotp: function () {
        const json = {
          biz: "SSInfogetMotp",
          callback: "SSSInfogetMotp_certnStupModfiMotp_callback",
          isLoading: true,
          bizParam: {},
        };
        this.bridgeCall(json);
      },
      /**
       * toekn otp 재등록 시, 발급정보를 가져온다. (toekn otp 재등록)
       */
      SSInfogetMotp_reregisterOtp: function () {
        const json = {
          biz: "SSInfogetMotp",
          callback: "SSInfogetMotp_reregisterOtp_callback",
          isLoading: true,
          bizParam: {},
        };
        this.bridgeCall(json);
      },
      /**
       * 서비스 가입 시, MOTP 발급정보를 가져온다. (서비스 가입 신청)
       */
      SSInfogetMotp_mOtpExstYN: function () {
        const json = {
          biz: "SSInfogetMotp",
          callback: "SSInfogetMotp_mOtpExstYN_callback",
          isLoading: true,
          bizParam: {},
        };
        this.bridgeCall(json);
      },
      /**
       * mOTP폐기및사고신고 시, 발급정보를 가져온다.
       */
      SSInfogetMotp_discardOrReportMotp: function () {
        const json = {
          biz: "SSInfogetMotp",
          callback: "SSInfogetMotp_discardOrReportMotp_callback",
          isLoading: true,
          bizParam: {},
        };
        this.bridgeCall(json);
      },
      /**
       * mOTP 인증을 호출한다.(native키패드를 열고 mpin을 입력 받음) (pin관리)
       * @param {*} certInfo
       */
      SSGenerateMotp_pinNoMgt: function (certInfo) {
        const json = {
          biz: "SSGenerateMotp",
          callback: "SSGenerateMotp_pinNoMgt_callback",
          isLoading: true,
          bizParam: {
            strUserId: certInfo.strUserId,
            strPeriod: certInfo.strPeriod,
            strSystemId: certInfo.strSystemId,
          },
        };
        this.bridgeCall(json);
      },
      /**
       * fido 등록을 실행한다.
       * @param {*} certInfo
       */
      fidoReg: function (fidoInfo) {
        const json = {
          biz: "fidoReg",
          callback: "fidoReg_callback",
          isLoading: true,
          bizParam: {
            userName: fidoInfo.userName,
            bioType: fidoInfo.bioType,
            systemId: fidoInfo.systemId,
            fidoReqMessage: JSON.stringify(fidoInfo.fidoReqMessage),
          },
        };
        this.bridgeCall(json);
      },
      /**
       * 앱 종료시킨다
       */
      exitApp: function () {
        const json = {
          biz: "exitApp",
        };
        this.bridgeCall(json);
      },
      /**
       * fido 인증을 실행한다
       */
      fidoCertn: function (fidoInfo) {
        store.state.auth.createFido.fidoCertn.appReq.in.userName = fidoInfo.userName;
        const json = {
          biz: "fidoCertn",
          callback: "fidoCertn_callback",
          isLoading: true,
          bizParam: {
            userName: fidoInfo.userName,
            bioType: fidoInfo.bioType,
            systemId: fidoInfo.systemId,
            fidoReqMessage: JSON.stringify(fidoInfo.fidoReqMessage),
          },
        };
        this.bridgeCall(json);
      },
      /**
       * fido 인증을 실행한다
       */
      fidoCertn_general: function (fidoInfo) {
        store.state.auth.createFido.fidoCertn.appReq.in.userName = fidoInfo.userName;
        const json = {
          biz: "fidoCertn",
          callback: "fidoCertn_callback_general",
          isLoading: true,
          bizParam: {
            userName: fidoInfo.userName,
            bioType: fidoInfo.bioType,
            systemId: fidoInfo.systemId,
            fidoReqMessage: JSON.stringify(fidoInfo.fidoReqMessage),
          },
        };
        this.bridgeCall(json);
      },
      /**
       * fido 인증을 실행한다 - 인증공통
       */
      fidoCertn_supplCertn: function (fidoInfo) {
        store.state.auth.createFido.fidoCertn.appReq.in.userName = fidoInfo.userName;
        const json = {
          biz: "fidoCertn",
          callback: "fidoCertn_callback_supplCertn",
          isLoading: true,
          bizParam: {
            userName: fidoInfo.userName,
            bioType: fidoInfo.bioType,
            systemId: fidoInfo.systemId,
            fidoReqMessage: JSON.stringify(fidoInfo.fidoReqMessage),
          },
        };
        this.bridgeCall(json);
      },
      /**
       * 간편인증번호 로그인을 통한 fido 등록을 위해 간편로그인한다
       */
      fidoReg_simpleLogin: function (fidoInfo) {
        store.state.auth.createFido.fidoCertn.appReq.in.userName = fidoInfo.userName;
        const json = {
          biz: "fidoCertn",
          callback: "fidoReg_callback_simpleLogin",
          isLoading: true,
          bizParam: {
            userName: fidoInfo.userName,
            bioType: fidoInfo.bioType,
            systemId: fidoInfo.systemId,
            fidoReqMessage: JSON.stringify(fidoInfo.fidoReqMessage),
          },
        };
        this.bridgeCall(json);
      },
      /**
       * 간편인증번호 로그인을 통한 fido 등록으로 fido 등록을 요청한다
       */
      fidoReg_fidoReq: function (fidoInfo) {
        const json = {
          biz: "fidoReg",
          callback: "fidoReg_callback_fidoReq",
          isLoading: true,
          bizParam: {
            userName: fidoInfo.userName,
            bioType: fidoInfo.bioType,
            systemId: fidoInfo.systemId,
            fidoReqMessage: JSON.stringify(fidoInfo.fidoReqMessage),
          },
        };
        this.bridgeCall(json);
      },
      /**
       * fido 간편인증번호 등록시, native 키패드를 호출한다.(첫번째)
       */
      openKeypadForFidoReg1: function () {
        const json = {
          biz: "openKeypadForFidoReg1",
          callback: "sendKeypadData_callback_Fido",
          bizParam: {
            inputId: "mPin01",
          },
        };
        this.bridgeCall(json);
      },
      /**
       * fido 간편인증번호 등록시, native 키패드를 호출한다.(두번째)
       */
      openKeypadForFidoReg2: function () {
        const json = {
          biz: "openKeypadForFidoReg2",
          callback: "sendKeypadData_callback_Fido",
          bizParam: {
            inputId: "mPin02",
          },
        };
        this.bridgeCall(json);
      },
      /**
       * fido 등록완료된 사용자 정보를 기기에 저장
       */
      setFidoReg: function (fidoRegInfo) {
        const json = {
          biz: "setFidoReg",
          isLoading: true,
          bizParam: {
            userName: fidoRegInfo.userName,
            bioType: fidoRegInfo.bioType,
          },
        };
        this.bridgeCall(json);
      },
      /**
       * 기기에 등록된 fido 정보 전체를 요청. - 로그인 전(로그아웃시 store 초기화로 index.js에 위치함)
       */
      fidoRegInfo_bfLogin: function () {
        const json = {
          biz: "fidoRegInfo",
          callback: "fidoRegInfo_callback_bfLogin",
          isLoading: true,
          bizParam: {},
        };
        this.bridgeCall(json);
      },
      /**
       * 기기에 등록된 fido 정보 전체를 요청. - 로그인 후
       */
      fidoRegInfo: function () {
        const json = {
          biz: "fidoRegInfo",
          callback: "fidoRegInfo_callback",
          isLoading: true,
          bizParam: {},
        };
        this.bridgeCall(json);
      },
      /**
       * 기기에 등록된 fido 정보 전체를 요청. - 인증공통
       */
      fidoRegInfo_supplCertn: function () {
        const json = {
          biz: "fidoRegInfo",
          callback: "fidoRegInfo_supplCertn_callback",
          isLoading: true,
          bizParam: {},
        };
        this.bridgeCall(json);
      },
      /**
       * 간편로그인 설정정보를 기기에 저장
       */
      setSimpleLogin: function (simpleLoginInfo) {
        /* 간편로그인 설정 저장 시 state.simpleLogin 내용 update */
        store.state.simpleLogin.fidoid = simpleLoginInfo.userName; /** 간편로그인 아이디 **/
        store.state.simpleLogin.bioType = simpleLoginInfo.bioType; /** 간편로그인 인증수단 - 마지막에 등록한 인증수단 (IDPW/PINCODE/FINGERPRINT) **/
        store.state.simpleLogin.selectedLoginType = simpleLoginInfo.bioType; /** 로그인 화면 표시 (IDPW/PINCODE/FINGERPRINT) **/
        const json = {
          biz: "setSimpleLogin",
          bizParam: {
            userName: simpleLoginInfo.userName,
            bioType: simpleLoginInfo.bioType,
            siteCode: simpleLoginInfo.siteCode,
          },
        };
        this.bridgeCall(json);
      },
      /**
       * 간편로그인 설정정보를 요청.
       */
      simpleLogin: function (paramInfo) {
        const json = {
          biz: "simpleLogin",
          callback: "simpleLogin_callback",
          isLoading: true,
          bizParam: {
            siteCode: paramInfo.siteCode,
          },
        };
        this.bridgeCall(json);
      },
      /**
       * 비로그인 마지막 접속한 간편로그인 설정정보를 요청.
       */
      lastSimpleLogin: function (paramInfo) {
        const json = {
          biz: "simpleLogin",
          callback: "lastSimpleLogin_callback",
          isLoading: true,
          bizParam: {
            siteCode: paramInfo.siteCode,
          },
        };
        this.bridgeCall(json);
      },
      /**
       * 해당 URL로 이동.(ios)
       */
      goURL: function (url) {
        const json = {
          biz: "goURL",
          bizParam: {
            url: url,
          },
        };
        this.bridgeCall(json);
      },
      /**
       * 해당 URL로 이동.(안드로이드)
       */
      fileDownload: function (url) {
        const json = {
          biz: "fileDownload",
          bizParam: {
            url: url,
          },
        };
        this.bridgeCall(json);
      },
      /**
       * 인증공통에서 mOtp 발급정보를 가져온다
       */
      SSInfogetMotp_supplCertn: function () {
        const json = {
          biz: "SSInfogetMotp",
          callback: "SSInfogetMotp_supplCertn_callback",
          isLoading: true,
          bizParam: {},
        };
        this.bridgeCall(json);
      },
      /**
       * mOTP 인증을 호출한다.- 인증공통
       * @param {*} certInfo
       */
      SSGenerateMotp_supplCertn: function (certInfo) {
        const json = {
          biz: "SSGenerateMotp",
          callback: "SSGenerateMotp_supplCertn_callback",
          isLoading: true,
          bizParam: {
            strUserId: certInfo.strUserId,
            strPeriod: certInfo.strPeriod,
            strSystemId: certInfo.strSystemId,
          },
        };
        this.bridgeCall(json);
      },
      /**
       * mOTP 인증을 호출한다.(native키패드 없이..) - mOTP PC인증
       * @param {*} certInfo
       */
      SSGenerateMotp_supplCertn_ReGenerate: function (certInfo) {
        const json = {
          biz: "SSGenerateMotp_ReGenerate",
          callback: "SSGenerateMotp_supplCertn_callback",
          isLoading: true,
          bizParam: {
            strUserId: certInfo.strUserId,
            strPeriod: certInfo.strPeriod,
            strSystemId: certInfo.strSystemId,
          },
        };
        this.bridgeCall(json);
      },
      /**
       * fido 해지을 실행한다.
       * @param {*} certInfo
       */
      fidoDiscard: function (fidoInfo) {
        const json = {
          biz: "fidoDiscard",
          callback: "fidoDiscard_callback",
          isLoading: true,
          bizParam: {
            userName: fidoInfo.userName,
            bioType: fidoInfo.bioType,
            systemId: fidoInfo.systemId,
            fidoReqMessage: JSON.stringify(fidoInfo.fidoReqMessage),
          },
        };
        this.bridgeCall(json);
      },
      /**
       * fido 지문 인증 취소 - android 중 지문입력 modal 화면이 없는경우?
       */
      fidoFingerprintCancel: function () {
        const json = {
          biz: "fidoFingerprintCancel",
          bizParam: {},
        };
        this.bridgeCall(json);
      },
      /**
       * 기기에 등록된 생체인증 정보 유무를 반환함
       */
      registeredBiometry: function () {
        const json = {
          biz: "registeredBiometry",
          callback: "registeredBiometry_callback",
          isLoading: true,
          bizParam: {},
        };
        this.bridgeCall(json);
      },
      /**
       * 앱실행 권한 체크
       */
      requestPermission: function () {
        const json = {
          biz: "requestPermission",
          callback: "requestPermission_callback",
          isLoading: true,
          bizParam: {},
        };
        this.bridgeCall(json);
      },
      /**
       * Apple Store 브릿지 통신 AppleStore로 바로 이동한다.
       */
      goAppleStore: function () {
        const json = {
          biz: "goAppleStore",
        };
        this.bridgeCall(json);
      },
      /**
       * native splash 이미지를 닫는다.
       */
      closeSplash: function () {
        const json = {
          biz: "closeSplash",
          bizParam: {},
        };
        this.bridgeCall(json);
      },
      /**
       * qr 인증 호출
       * country code = code 전송
       */
      qrScanForTransfer: function (code) {
        const json = {
          biz: "qrScanForTransfer",
          callback: "qrScanForTransfer_callback",
          bizParam: {
            code: code,
          },
        };
        this.bridgeCall(json);
      },
      /**
       * OCR 인증 호출
       */
      recognizeId: function (type) {
        const json = {
          biz: "recognizeId",
          callback: "recognizeId_callback",
          isLoading: true,
          bizParam: {
            idType: type,
          },
        };
        this.bridgeCall(json);
      },

      /**
       * QR From Gallery
       */
      getQRFromGallery: function () {
        console.log("QR From Gallery");
        const json = {
          biz: "getQRFromGallery",
          callback: "getQRFromGallery_callback",
          bizParam: {},
        };
        this.bridgeCall(json);
      },

      sendCaptureImgToApp: function (path, name) {
        const json = {
          biz: "sendCaptureImgToApp",
          callback: "sendCaptureImgToApp_callback",
          bizParam: {
            path: path,
            name: name,
          },
        };
        this.bridgeCall(json);
      },

      shareCaptureImg: function (imagePath) {
        console.log("이미지 공유하기" + imagePath);
        const json = {
          biz: "shareCaptureImg",
          callback: "shareCaptureImg_callback",
          bizParam: {
            path: imagePath,
          },
        };

        this.bridgeCall(json);
      },

      // myQr에서 캡처 / myQr에서 공유
      shareCaptureMyQR: function (width, height) {
        const json = {
          biz: "shareCaptureMyQR",
          callback: "shareCaptureMyQR_callback",
          bizParam: {
            width: width,
            height: height,
          },
        };

        this.bridgeCall(json);
      },

      sendCaptureMyQRToApp: function (width, height) {
        const json = {
          biz: "sendCaptureMyQRToApp",
          callback: "sendCaptureMyQRToApp_callback",
          bizParam: {
            width: width,
            height: height,
          },
        };
        this.bridgeCall(json);
      },
      /**
       * 권한 체크
       */
      checkPermissions: function (permissions) {
        console.log("권한 체크 | " + permissions);
        const json = {
          biz: "checkPermissions",
          callback: "checkPermissions_callback",
          bizParam: {
            permissions: permissions,
          },
        };

        this.bridgeCall(json);
      },
      /**
       * 권한 요청
       */
      requestPermissions: function (permissions) {
        console.log("권한 요청 | " + permissions);
        const json = {
          biz: "requestPermissions",
          callback: "requestPermissions_callback",
          bizParam: {
            permissions: permissions,
          },
        };

        this.bridgeCall(json);
      },
      //신분증 or 여권 촬영 브릿지콜 "0": 신분증(내국인),"1": 여권(외국인)
      scanIdentityData: function (operGroupCd, type, baseUrl) {
        const json = {
          biz: "scanIdentityData",
          callback: "scanIdentityData_callback",
          bizParam: {
            operGroupCd: operGroupCd,
            type: type,
            baseUrl: baseUrl,
          },
        };

        this.bridgeCall(json);
      },

      //셀카촬영 브릿지콜
      scanSelfieData: function (operGroupCd, type, data, baseUrl) {
        const json = {
          biz: "scanSelfieData",
          callback: "scanSelfieData_callback",
          bizParam: {
            operGroupCd: operGroupCd,
            type: type,
            data: data,
            baseUrl: baseUrl,
          },
        };

        this.bridgeCall(json);
      },

      //NFC 인식 브릿지콜
      // version은 별도로 추가(테스트용)
      readNFCData: function (operGroupCd, ver) {
        const json = {
          biz: "readNFCData",
          callback: "readNFCData_callback",
          bizParam: {
            operGroupCd: operGroupCd,
            version: ver,
          },
        };

        this.bridgeCall(json);
      },

      // 베트남 대표계좌 지정 QR Widget, type: "0" 이면 대표계좌 지정
      setWidgetInfo: function (type, data) {
        const json = {
          biz: "setWidgetInfo",
          callback: "setWidgetInfo_callback",
          bizParam: {
            type: type,
            data: data,
          },
        };

        this.bridgeCall(json);
      },

      // api테스트
      addFileAPITest: function () {
        const json = {
          biz: "addFileAPITest",
          callback: "addFileAPITest_callback",
          bizParam: {
            data: "TEST",
          },
        };
        this.bridgeCall(json);
      },
      // DeepLink Test
      moveToAppStore: function (dataType) {
        const json = {
          biz: "moveToAppStore",
          callback: "moveToAppStore_callback",
          bizParam: {
            data: dataType, // 0 = PUSH, 1 = SMS (예시)
          },
        };
        this.bridgeCall(json);
      },
      // DeepLink Test
      moveToGoogleStore: function () {
        const json = {
          biz: "moveToGoogleStore",
          callback: "moveToGoogleStore_callback",
          bizParam: {
            data: dataType, // 0 = PUSH, 1 = SMS (예시)
          },
        };
        this.bridgeCall(json);
      },
    };
  },
};
